module.exports = __webpack_public_path__ + "media/images/login_logo_reset-ff6489d0.png";